/**
 * Toggles the search bar when icon is clicked
 * @author Jess McClary <https://gitbhub.com/kinsDeveloper
 */

(function ($) {
  'use strict';

  let $searchIcon;
  let $searchBar;
  let $searchInput;

  Drupal.behaviors.initializeSearchBar = {
    attach: (context) => {
      if (context === document) {
        initialize();
      }
    },
  };

  function initialize() {
    $searchIcon = $('.search-icon');
    $searchBar = $('.search-form');
    $searchInput = $('#views-exposed-form-site-search-page-1', $searchBar);

    $searchIcon.on('click', handleClick);
  }

  function handleClick() {
    $searchBar.css('visibility', 'visible');

    $searchIcon.toggleClass('is-active');
    $searchBar.toggleClass('is-active');
    if ($searchBar.hasClass('is-active')) $searchInput.focus();
  }
})(jQuery);
